import { IconProps } from "../../utils/global-types/global-types";

const InvestorIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 17 17"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        d="M6.856 6.967a2.807 2.807 0 1 0 0-5.61 2.807 2.807 0 0 0 0 5.61Z"
        fill="currentColor"
      />
      <path
        d="M8.331 11.952c0-1.754 1.086-3.254 2.623-3.87a5.556 5.556 0 0 0-2.146-1.271 3.106 3.106 0 0 1-.966.49l-.72 1.088.733 2.36a.243.243 0 0 1-.03.207l-.768 1.134a.243.243 0 0 1-.4 0l-.766-1.134a.243.243 0 0 1-.032-.207l.733-2.36-.717-1.086a3.107 3.107 0 0 1-.972-.496C2.53 7.618.815 9.868.802 12.51a.244.244 0 0 0 .243.243h7.367a4.084 4.084 0 0 1-.068-.493 2.84 2.84 0 0 1-.013-.308Z"
        fill="currentColor"
      />
      <path
        d="M12.505 8.266a3.685 3.685 0 0 0-3.687 3.685c0 .093.003.187.01.273a3.69 3.69 0 0 0 3.677 3.42 3.693 3.693 0 0 0 3.688-3.509 3.574 3.574 0 0 0 .005-.184 3.685 3.685 0 0 0-3.693-3.685Zm-.377 3.235a.487.487 0 0 0 .386.172c.572.015 1.026.493 1.01 1.065a1.003 1.003 0 0 1-.774.973v.37a.243.243 0 0 1-.486 0v-.356a1.002 1.002 0 0 1-.531-.3.997.997 0 0 1-.285-.741.243.243 0 0 1 .487-.013.493.493 0 0 0 .151.395.493.493 0 0 0 .386.171h.015a.533.533 0 0 0 .552-.537.533.533 0 0 0-.538-.566 1.003 1.003 0 0 1-1.01-1.065 1.003 1.003 0 0 1 .774-.973v-.37a.243.243 0 0 1 .486 0v.357a1.007 1.007 0 0 1 .53.3 1.001 1.001 0 0 1-.243 1.554.493.493 0 0 0-.151-.394.493.493 0 0 0-.386-.172.534.534 0 0 0-.552.538c-.004.147.05.288.151.395Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InvestorIcon;
